module.exports = __webpack_public_path__ + "img/index-m-slide2.dbd5d276.jpg";